export function isElementVisible(element: HTMLElement | null): boolean {
  if (!element?.isConnected) return false;

  for (let current: HTMLElement | null = element; current; current = current.parentElement) {
    if (
      current.hidden ||
      current.inert ||
      current.getAttribute('aria-hidden') === 'true'
    ) {
      return false;
    }

    const style = current.ownerDocument.defaultView?.getComputedStyle(current);
    if (
      style?.display === 'none' ||
      style?.visibility === 'hidden' ||
      style?.visibility === 'collapse' ||
      style?.contentVisibility === 'hidden'
    ) {
      return false;
    }
  }

  return true;
}
